import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { environment } from '../../../environments/environment';

const apiUrl = '/spring/auth/login';
let serviceCode = '';
serviceCode = environment.serviceCode;

@Injectable()
export class AuthLoginService {

  constructor(private http: Http) { }

  execute(userCd: string, password: string, companyCd: string, apiKey: string): Promise<any> {

    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + apiUrl;

    if(localStorage.getItem('apiKey').length === 0) {
      return Promise.reject(new Error('APIキーがセットされていません。'));
    }

    const headers = new Headers({
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
      'x-service-code': serviceCode,
      'x-session-key': '',
      'x-csrf-token': ''
    });

    const jsonInput = {
      userCd: userCd,
      password: password,
      companyCd: companyCd,
      apiKey: apiKey,
    };

    return this.http
      .post(url, JSON.stringify(jsonInput), { headers: headers })
      .toPromise()
      .then(response => response.json() as any)
      .catch(error => {
        console.log('error:' + error);
        let err = error;
        if (error.status === 0) {
          err = new Error('サーバへ接続できませんでした。');
        }
        return Promise.reject(err);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/auth-login/auth-login.service.ts